import { InjectorLoggingUtils } from './injector-logging-utils';
const { GetMissingServiceMsg, GetMissingServicePropertyMsg, SetMissingServicePropertyMsg, CallMissingServiceMethodMsg } = InjectorLoggingUtils;
function defaultLogger(msg, ...args) {
    console.error('[InjectorProxy] ', msg, ...args);
}
/**
 * Ignore irrelevant behavior, such as angular dynamic properties enrichment.
 */
export function supportedPropsFilter(subject) {
    return !(subject && subject.startsWith('$'));
}
export class ServiceProxyHandler {
    propsFilter;
    onGetMissingServiceProperty;
    onSetMissingServiceProperty;
    onCallMissingServiceMethod;
    constructor({ propsFilter = supportedPropsFilter, onGetMissingServiceProperty = defaultLogger, onSetMissingServiceProperty = defaultLogger, onCallMissingServiceMethod = defaultLogger, } = {}) {
        this.propsFilter = propsFilter;
        this.onGetMissingServiceProperty = onGetMissingServiceProperty;
        this.onSetMissingServiceProperty = onSetMissingServiceProperty;
        this.onCallMissingServiceMethod = onCallMissingServiceMethod;
    }
    get(target, name) {
        if (name === Symbol.toStringTag) {
            return target.toString();
        }
        if (name in target)
            return target[name];
        if (this.propsFilter(name.toString())) {
            const msg = GetMissingServicePropertyMsg(name);
            this.onGetMissingServiceProperty(msg, name.toString());
            return new Proxy({}, this);
        }
    }
    set(target, name, value) {
        if (!(name in target) && this.propsFilter(name.toString())) {
            const msg = SetMissingServicePropertyMsg(name, value);
            this.onSetMissingServiceProperty(msg, name.toString(), value);
        }
        target[name] = value;
        return true;
    }
    apply(target, thisArg, argsList) {
        if (!target) {
            const thisArgStr = JSON.stringify(thisArg);
            const msg = CallMissingServiceMethodMsg(thisArgStr, argsList);
            this.onCallMissingServiceMethod(msg, thisArgStr, argsList);
            return new Proxy({}, this);
        }
        return target.apply(thisArg, argsList);
    }
}
export class InjectorProxyHandler {
    injector;
    onGetMissingService;
    serviceProxyHandler;
    constructor({ injector, onGetMissingService = defaultLogger }) {
        this.injector = injector;
        this.onGetMissingService = onGetMissingService;
        this.serviceProxyHandler = new ServiceProxyHandler(arguments[0]);
    }
    get(target, name) {
        if (name === Symbol.toStringTag)
            return target.toString();
        if (name in target)
            return target[name];
        let service = null;
        try {
            service = this.injector(name);
        }
        catch (err) { }
        if (!service) {
            const msg = GetMissingServiceMsg(name);
            this.onGetMissingService(msg, name);
        }
        target[name] = new Proxy(service || {}, this.serviceProxyHandler);
        return target[name];
    }
}
export function injectorProxy(options) {
    return new Proxy({}, new InjectorProxyHandler(options));
}
//# sourceMappingURL=injector-proxy.js.map